import {Component, Input, OnChanges} from '@angular/core';
import {ObservationTarget} from "@webmate-web-core/shared/types/testmgmt";
import {StateModule} from "@webmate-web-core/shared/components/state/state.module";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

import {WmDirectivesModule} from "@webmate-web-core/shared/directives/directives.module";
import {faBox} from "@fortawesome/pro-light-svg-icons";
import {DockModule} from "primeng/dock";
import {Tooltip} from 'primeng/tooltip';
import {ImageService} from '@webmate-web-core/shared/services/image.service';

@Component({
    selector: 'wm-test-object-summary',
    templateUrl: './test-object-summary.component.html',
    styleUrls: ['./test-object-summary.component.less'],
    standalone: true,
    imports: [
        FontAwesomeModule,
        WmDirectivesModule,
        StateModule,
        DockModule,
        Tooltip,
    ]
})
export class TestObjectSummaryComponent implements OnChanges {
    @Input() target: ObservationTarget;
    @Input() representativeStateId?: string;

    screenshotUrl?: string;

    constructor(
        private readonly imageService: ImageService
    ) {}

    ngOnChanges() {
        this.screenshotUrl = this.target?.screenshot
            ? this.imageService.getImageUrl(this.target.screenshot, "medium")
            : undefined;
    }

    protected readonly faBox = faBox;
}
